function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { display, fontSize, fontStyle, fontWeight, height, letterSpacing, lineHeight, maxHeight, maxWidth, minHeight, minWidth, overflow, space, textAlign, textStyle, width, zIndex } from 'styled-system';
import { applyVariations, deprecatedColorValue, deprecatedPropType, getPaletteColor, textAlignAttrs, textStylesValues, typographyAttrs } from '../utils';
export var caps = function caps(props) {
  return props.caps ? {
    textTransform: 'uppercase'
  } : null;
};
export var regular = function regular(props) {
  return props.regular ? {
    fontWeight: props.theme.regular
  } : null;
};
export var bold = function bold(props) {
  return props.bold ? {
    fontWeight: props.theme.bold
  } : null;
};
export var textDecoration = function textDecoration(props) {
  return props.textDecoration ? "text-decoration: ".concat(props.textDecoration, ";") : '';
};
export var textShadow = function textShadow(props) {
  var textShadowSize = props.textShadowSize || 'md';
  return props.enableTextShadow ? {
    textShadow: props.theme.textShadows[textShadowSize]
  } : null;
};
var textProps = css(["", " color:", ";", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], applyVariations('Text'), getPaletteColor('base'), function (props) {
  return props.bg ? "background-color: ".concat(getPaletteColor(props.bg, 'base')(props), ";") : '';
}, display, height, maxHeight, maxWidth, minHeight, minWidth, overflow, space, width, caps, regular, bold, fontSize, fontStyle, fontWeight, lineHeight, letterSpacing, textAlign, textDecoration, textShadow, textStyle, zIndex);

var textAttrs = function textAttrs(props) {
  return _objectSpread(_objectSpread({}, typographyAttrs(props)), textAlignAttrs(props));
};

var Text = styled.div.attrs(textAttrs).withConfig({
  displayName: "Text",
  componentId: "sc-1c7ae3w-0"
})(["", ""], textProps);
var Span = styled.span.attrs(textAttrs).withConfig({
  displayName: "Text__Span",
  componentId: "sc-1c7ae3w-1"
})(["", ""], textProps);
var Paragraph = styled.p.attrs(textAttrs).withConfig({
  displayName: "Text__Paragraph",
  componentId: "sc-1c7ae3w-2"
})(["", ""], textProps);
var Strike = styled.s.attrs(textAttrs).withConfig({
  displayName: "Text__Strike",
  componentId: "sc-1c7ae3w-3"
})(["", ""], textProps);
Text.displayName = 'Text';
Text.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, display.propTypes), fontSize.propTypes), fontStyle.propTypes), fontWeight.propTypes), height.propTypes), lineHeight.propTypes), maxHeight.propTypes), maxWidth.propTypes), minHeight.propTypes), minWidth.propTypes), overflow.propTypes), space.propTypes), textAlign.propTypes), textStyle.propTypes), width.propTypes), zIndex.propTypes), {}, {
  align: deprecatedPropType('textAlign'),
  bold: PropTypes.bool,
  caps: PropTypes.bool,
  color: deprecatedColorValue(),
  enableTextShadow: PropTypes.bool,
  regular: PropTypes.bool,
  textDecoration: PropTypes.string,
  textShadowSize: PropTypes.oneOf(['sm', 'md']),
  textStyle: PropTypes.oneOf(textStylesValues)
});
Text.span = Span;
Text.span.displayName = 'Text.span';
Text.p = Paragraph;
Text.p.displayName = 'Text.p';
Text.s = Strike;
Text.s.displayName = 'Text.s';
export default Text;